import { api } from '@/services'

export async function addPartnerRequest(
  id: string,
  credenciadoId: string,
  transportedId?: string
) {
  try {
    const { data } = await api.post('Cart/SelecionarCentroMontagem', null, {
      params: {
        CheckoutId: id,
        CredenciadoId: credenciadoId
      }
    })

    if (transportedId) {
      api.post('Cart/RemoverFreteSelecionado', {
        params: {
          CheckoutId: id,
          TransporterId: transportedId
        }
      })
    }

    return { data }
  } catch (error) {
    console.error(error)
  }
}
